module.exports = __webpack_public_path__ + "icons/success-icon.e902d696.svg";